module.exports = __webpack_public_path__ + "images/2abcbf66fb9ed69b66d2127a005848e5.jpg";